'use client'
import React, { useTransition } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog/dialog'
import Image from 'next/image'
import ErrorImg from '@/public/image/error-image.svg'
import { Button } from '@/components/ui/button/button'
import { RotateCcw } from 'lucide-react'

interface ErrorContentProps {
  title: string
  description: string
  callToAction: () => void
}

//For "If user can re-try immediately" use ErrorContent component
const ErrorContent = ({
  title,
  description,
  callToAction,
}: ErrorContentProps) => {
  const errorTitle: string = title || 'Unknown Error Occurred'
  const errorDescription: string = description || 'Something went wrong'

  const [isPending, startTransition] = useTransition()
  const handleClick = () => startTransition(() => callToAction())

  return (
    <div>
      <Dialog defaultOpen={true}>
        <DialogContent className="sm:max-w-[350px] sm:rounded-3xl md:max-w-[470px]">
          <DialogHeader>
            <Image
              src={ErrorImg}
              alt="Oops!-Something-doesn't-seem-right"
              className="mx-auto my-4"
            />
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogDescription className="text-wrap text-center text-sm text-muted-foreground">
              {errorDescription}
            </DialogDescription>
          </DialogHeader>
          <hr className="border-dashed border-gray-300" />
          <div className="flex flex-col items-center"></div>
          <DialogFooter>
            <Button
              variant="gooeyRight"
              className="m-2 h-14 px-20 2xl:px-32"
              onClick={handleClick}
              disabled={isPending}
              transactionName="error-content.try-again"
            >
              Try again{' '}
              <RotateCcw
                className={`m-4 w-5 ${isPending ? 'animate-spin' : ''}`}
              />
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ErrorContent
